import { render, staticRenderFns } from "./AddEditActiveInstructor.vue?vue&type=template&id=2f52a27a&scoped=true"
import script from "./AddEditActiveInstructor.vue?vue&type=script&lang=js"
export * from "./AddEditActiveInstructor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f52a27a",
  null
  
)

export default component.exports